import React, { Component } from 'react'
import '../ProjectView/style.css'
import './style.css'
import {Link} from 'react-router-dom'
import 'font-awesome/css/font-awesome.min.css';

class DetailsBag extends Component {
  componentDidMount(){
    window.scrollTo(0, 0);
  }

  render(){
    return(
      <div>
        <div className="header" style={{  backgroundImage: `url(${process.env.PUBLIC_URL + '/images/bag-hero.png'})` }}>
          <Link to='/'>
            <i class="fa fa-chevron-left" aria-hidden="true"></i>
          </Link>
          <h3 className="date" style={{color: "#3D8E8D"}}>Summer and Fall 2021</h3>
          <h1>Beyond the Bag</h1>
          <h3>IDEO • Innovation Lead</h3>
        </div>
        <div className="main">
          <p className="summary">
            IDEO hosted the Beyond the Bag Challenge on behalf of Closed Loop Partners throughout 2021. 
            It called innovators from around the world to the challenge of providing a replacement solution to the single-use plastic bag for retailers across the US.
      <br/>
            I joined the team as the Innovation Lead, working directly with the winning innovators to prepare them for piloting in our Founding Partner Retailers Walmart, Target, and CVS. 
            For 7 weeks, we piloted 3 solutions across 9 stores in the Bay Area with thousands of real customers, iterating their services in the wild.
          </p>
          
          {/* <img className="hero" src={process.env.PUBLIC_URL + '/images/pars/HCTC-SealLone.png'} /> */}

        <iframe className="youtube" src="https://player.vimeo.com/video/663090912?h=6f4cf87637" frameborder="0" allowfullscreen></iframe>
        
        <h2>Getting Started</h2>
          <p>In the months prior to the pilot, we had to determine what were the core questions about these innovative solutions that
            had to be answered in order to de-risk further roll-out of these solutions nationwide with our retail partners.
            This process involved Miro workshops where we determined the assets of each innovator, broke down what the core of their service offering was, 
            and even running a smaller scale prototype at the retailer's headquarters so they could get their hands on the solutions and we can determine our questions.
            <br/>
            This involved collaboration across many, many functions, as in classic IDEO fashion, we focused on doing so in a playful and collaborative manner to establish that all parties here were together for one mission: to mitigate the single-use plastic bag from stores nationwide.
          </p>
            <img  src={process.env.PUBLIC_URL + '/images/miro.gif'} />
          <p className="subtitle">One of our many Miro board exercise we conducted across all 7 innovators</p>
          <h2>Preparing for Pilots</h2>
          <p>
            Once we knew our core questions as well as our piloting locations, we set off to create our build list on what was necessary for the innovators to produce
            to handle a 7 week live pilot. And with these being in real stores with real customers, each asset of the innovator had to be clearly justified and go through any necessary approval.
            This was the ultimate challenge of working within constraints, and it helped us focus on what was the true core offering of these innovative solutions.
          </p>
          <img className="halfImage"  src={process.env.PUBLIC_URL + '/images/Fill it forward package gif.gif'} />
          <img className="halfImage"  src={process.env.PUBLIC_URL + '/images/s4BjLF1o.jpeg'} />
          <p className="subtitle">Matt Wittek, CEO of Fill It Forward with a prototype of the bag tag (left) and then the pilot version in stores (right) </p>

          <h2>The Pilots</h2>
          <p>
            For the 7 weeks in August and September of 2021, our team and the innovators flew out to Palo Alto to test our solution across 9 Walmart's, Target's, and CVS's from San Jose to Redwood City.
            As the Innovation Lead, I had to work with each innovator to make sure all of their necessary assets were in store and ready to go. 
            This included hardware, bags, signage, speaking points for associates, 
            anything that was necessary to make sure that customers could engage with the bag solutions in their everyday shopping experience.

          </p>
          <img  src={process.env.PUBLIC_URL + '/images/goats-inthe-making.gif'} />
          <p className="subtitle">The GOATOTE Kiosk - from painting to shipping to in-store</p>
          <p>
            And once the solutions were in-store, our work was not done. No matter what, once the product is in a customer's hand, anything can go wrong, and it did.
            We had to be quick and nimble to create changes wherever necessary to make sure that the services worked seamlessly. Whether that meant re-printing posters to include other languages,
            or serving shifts as the reusable bag laundry delivery person, or even serving as the kiosk repair man, me alongside the innovators made sure the services were up and running for the full 3 weeks.
            And in addition to essential fixes, we collaborated with the amazing associates at the stores who were working everyday with these new products. Their invaluable expertise
            was an incredible source of design inspiration and ideation, which we would immediate bring back as prototypes into the field.
            <br/><br/>
            It was a whirlwind 7 weeks, but it was an incredibly creative space to build and design alongside some incredible people on a challenge worth taking on.
          
          </p>
          <img className="halfImage"  src={process.env.PUBLIC_URL + '/images/bags-require-lots-of-ideas.gif'} />
            <img className="halfImage"  src={process.env.PUBLIC_URL + '/images/shuya-and-takashis-decal-store-numberoneinSantaClaraCounty.gif'} />
            <img className="halfImage"  src={process.env.PUBLIC_URL + '/images/put-it-in-the-bags.gif'} />
            <img className="halfImage"  src={process.env.PUBLIC_URL + '/images/matt-the-gluer.gif'} />
            
            <h2>The Work in the Public</h2>
            <a href="https://www.ideo.com/journal/how-play-can-lead-the-way-to-a-sustainable-future" target="_blank" rel="noopener noreferrer">
              <div className="postLink">
                <img src={'https://media-exp1.licdn.com/dms/image/sync/C5627AQFm-Wf4Y3v3Iw/articleshare-shrink_1280_800/0/1651694416540?e=1653112800&v=beta&t=pe5X45NmjVjHNzsbLMj2eozq_5v7NMZzpignckJU9Xw'} />
                <h4>The IDEO Journal</h4>
                <h3>How Play Can Lead the Way to a Sustainable Future</h3>
              </div>
            </a>
            <a href="https://www.closedlooppartners.com/beyond-the-bag/" target="_blank" rel="noopener noreferrer">
              <div className="postLink">
                <img src={'https://media-exp1.licdn.com/dms/image/sync/C5627AQHbbaoiioo9_A/articleshare-shrink_800/0/1651696321713?e=1653112800&v=beta&t=zpU8TYIGp5aldjgKslTKyWbFG__FVQWY7nl2CmciiDk'} />
                <h4>Closed Loop Partners</h4>
                <h3>Beyond the Bag</h3>
              </div>
            </a>
            <a href="https://www.fastcompany.com/90742827/world-changing-idea-awards-2022-north-america-finalists-and-honorable-mentions" target="_blank" rel="noopener noreferrer">
              <div className="postLink">
                <img src={'https://slack-imgs.com/?c=1&o1=ro&url=https%3A%2F%2Fimages.fastcompany.net%2Fimage%2Fupload%2Fw_1280%2Cf_auto%2Cq_auto%2Cfl_lossy%2Fwp-cms%2Fuploads%2F2022%2F04%2FTop_Art_WCI_North_America.jpg'} />
                <h4>Fast Company</h4>
                <h3>These projects show how North American companies are working to make the world a better place</h3>
              </div>
            </a>
            <a href="https://www.fastcompany.com/90742401/world-changing-ideas-awards-2022-consumer-products-finalists-and-honorable-mentions" target="_blank" rel="noopener noreferrer">
              <div className="postLink">
                <img src={'https://slack-imgs.com/?c=1&o1=ro&url=https%3A%2F%2Fimages.fastcompany.net%2Fimage%2Fupload%2Fw_1280%2Cf_auto%2Cq_auto%2Cfl_lossy%2Fwp-cms%2Fuploads%2F2022%2F04%2FTop_Art_WCI_Consumer_Products.jpg'} />
                <h4>Fast Company</h4>
                <h3>27 consumer products that can help you change the world</h3>
              </div>
            </a>
            <a href="https://www.greenbiz.com/article/5-key-learnings-closed-loop-partners-reusable-packaging-pilots" target="_blank" rel="noopener noreferrer">
              <div className="postLink">
                <img src={'https://www.greenbiz.com/sites/default/files/2022-03/singleusemultiusebags_shutterstock_KryvenokAnastasiia.jpeg'} />
                <h4>GreenBiz</h4>
                <h3>5 key learnings from Closed Loop Partners' reusable packaging pilots</h3>
              </div>
            </a>
            <a href="https://www.greenbiz.com/article/inside-walmart-target-and-cvs-reusable-bag-pilots" target="_blank" rel="noopener noreferrer">
              <div className="postLink">
                <img src={'https://www.greenbiz.com/sites/default/files/2021-09/KelseyFloyd_BeyondTheBag_SocialSelects_23%20%281%29.jpg'} />
                <h4>GreenBiz</h4>
                <h3>Inside the Walmart, Target and CVS reusable bag pilots</h3>
              </div>
            </a>
        </div>

      </div>
    )
  }
}

export default DetailsBag



// WEBPACK FOOTER //
// ./src/components/ProjectDetailPage/project-bag.js